  
import {ReactNode} from 'react';

 
import {UserContext} from './UserContext';
import {useUserData} from './useUserData';

interface UserProviderProps {
  children: ReactNode;
}

const UserProvider = ({children}: UserProviderProps) => {
  const values = useUserData();

  return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
};

export {UserProvider};
